import {DerivationService} from '@shared/interfaces/derivation.interface';

export const SERVICE: { ih: DerivationService[]; noIh: DerivationService[] } = {
    ih: [
        {
            id: "3",
            specialty: "Otra Especialidad",
            service: ""
        },
        {
            id: "13",
            specialty: "Pre Dialisis",
            service: ""
        },
        {
            id: "9",
            specialty: "Psicopedagogia",
            service: ""
        },
        {
            id: '946024DA-B3A7-4B58-B985-AB3B00BF5413',
            specialty: 'Kinesiología',
            service: '',
        },
        {
            specialty: "Adolescencia",
            service: "General",
            id: "16496AD1-5237-4AC2-A5FD-A98A00F2095C",
            fonasaIds: ["0101309"],
            imedIds: ["0101803", "0101001", "0101814", "0101305", "0101849"]
        },
        {
            specialty: "Infectologia Pediatrica",
            service: "General TLM",
            id: "3602ED6F-2C3B-4C7B-8923-AB8500BA0D54",
            fonasaIds: ["0101303"],
            imedIds: ["0101898", "0101900"]
        },
        {
            specialty: "Adolescencia",
            service: "General TLM",
            id: "A9CC42AB-A101-488C-B286-AB92003A161D",
            fonasaIds: ["0101309"],
            imedIds: ["0101803", "0101001", "0101814", "0101305", "0101849"]
        },
        {
            specialty: "Anestesiologia",
            service: "Manejo Dolor Cronico",
            id: "FAB36173-EB33-4647-8A19-A98A00F1CC6F",
            fonasaIds: ["0101329"],
            imedIds: ["0101305", "0101849"]
        },
        {
            specialty: "Anestesiologia",
            service: "Manejo Dolor Cronico TLM",
            id: "EF3A9DD0-7082-4D1E-BB67-AB8500AC494F",
            fonasaIds: [
                "0101329"
            ],
            imedIds: [
                "0101305",
                "0101849"
            ]
        },
        {
            specialty: "Broncopulmonar Adultos",
            service: "General",
            id: "9DA5C64D-4C74-4913-9DAA-A98A00F1CE13",
            fonasaIds: [
                "0101321"
            ],
            imedIds: [
                "0101819"
            ]
        },
        {
            specialty: "Broncopulmonar Adultos",
            service: "General TLM",
            id: "DC19E9C5-5AF0-4BE1-B431-AB8500ACB238",
            fonasaIds: [
                "0101321"
            ],
            imedIds: [
                "0101819"
            ]
        },
        {
            specialty: "Broncopulmonar Pediatrico",
            service: "General",
            id: "B1383C0A-0178-4C8C-BE1A-A98A00F1CF7F",
            fonasaIds: [
                "0101322"
            ],
            imedIds: [
                "0101832",
                "0101973"
            ]
        },
        {
            specialty: "Broncopulmonar Pediatrico",
            service: "General TLM",
            id: "A3FD1F17-2DD3-4DB8-8FB3-AB8500AD20F2",
            fonasaIds: [
                "0101322"
            ],
            imedIds: [
                "0101832",
                "0101973"
            ]
        },
        {
            specialty: "Cardiologia Adultos",
            service: "General",
            id: "E5A95AA9-9DEF-49B7-8E76-A98A00F1D150",
            fonasaIds: [
                "0101301"
            ],
            imedIds: [
                "0101817"
            ]
        },
        {
            specialty: "Cardiologia Adultos",
            service: "General TLM",
            id: "59E3772D-6358-409A-9AA2-AB8500AD7B12",
            fonasaIds: [
                "0101301"
            ],
            imedIds: [
                "0101817"
            ]
        },
        {
            specialty: "Cardiologia Pediatrica",
            service: "General",
            id: "8F57CFC1-B202-4AD6-BE7A-A98A00F1D2AB",
            fonasaIds: [
                "0101301"
            ],
            imedIds: [
                "0101817",
                "0101804"
            ]
        },
        {
            specialty: "Cardiologia Pediatrica",
            service: "General TLM",
            id: "AC15D803-A297-4498-9706-AB8500ADD0D7",
            fonasaIds: [
                "0101301"
            ],
            imedIds: [
                "0101817",
                "0101804"
            ]
        },
        {
            specialty: "Cirugia Cardiaca",
            service: "Adulto",
            id: "48704D19-896E-4CE9-BA68-A98A00F1D37E",
            fonasaIds: [
                "0101314"
            ],
            imedIds: [
                "0101802",
                "0101800",
                "0101312"
            ]
        },
        {
            specialty: "Cirugia Cardiaca",
            service: "Adulto TLM",
            id: "7F9E48BE-253D-4760-8535-AB8500AE8192",
            fonasaIds: [
                "0101314"
            ],
            imedIds: [
                "0101802",
                "0101800",
                "0101312"
            ]
        },
        {
            specialty: "Cirugia Cardiaca",
            service: "Pediatria",
            id: "877E481A-1C91-4009-ADCC-A99E01457BC9",
            fonasaIds: [
                "0101312"
            ],
            imedIds: [
                "0101800",
                "0101802"
            ]
        },
        {
            specialty: "Cirugia Coloproctologica",
            service: "General",
            id: "62F4DBFC-C949-49ED-B786-A98A00F1D3C9",
            fonasaIds: [
                "0101319"
            ],
            imedIds: [
                "0101835",
                "0101800"
            ]
        },
        {
            specialty: "Cirugia Coloproctologica",
            service: "General TLM",
            id: "5C65C6F5-B7B0-4662-A2E4-AB8500AEF579",
            fonasaIds: [
                "0101319"
            ],
            imedIds: [
                "0101835",
                "0101800"
            ]
        },
        {
            specialty: "Cirugia Digestiva",
            service: "Cirugia Bariatrica",
            id: "1023514E-898D-45D6-BFA3-A9A60142AFB2",
            fonasaIds: [
                "0101312"
            ],
            imedIds: [
                "0101835",
                "0101800"
            ]
        },
        {
            specialty: "Cirugia Digestiva",
            service: "Cirugia Bariatrica PAD Fonasa",
            id: "531678D1-16DC-4E59-8A6E-B07400EF2F71",
            fonasaIds: [
                "0101312"
            ],
            imedIds: [
                "0101835",
                "0101800"
            ]
        },
        {
            specialty: "Cirugia Digestiva",
            service: "Cirugia Bariatrica PAD Fonasa TLM",
            id: "51E00220-1777-4643-AD27-B0C000D1E87B",
            fonasaIds: [
                "0101312"
            ],
            imedIds: [
                "0101835",
                "0101800"
            ]
        },
        {
            specialty: "Cirugia Digestiva",
            service: "Cirugia Bariatrica TLM",
            id: "F90E0538-4510-4098-80FB-ABA30155D951",
            fonasaIds: [
                "0101312"
            ],
            imedIds: [
                "0101835",
                "0101800"
            ]
        },
        {
            specialty: "Cirugia Digestiva",
            service: "General",
            id: "F43C3D6B-02FB-4D94-9D26-A98A00F1D434",
            fonasaIds: [
                "0101312"
            ],
            imedIds: [
                "0101835",
                "0101800"
            ]
        },
        {
            specialty: "Cirugia Digestiva",
            service: "General TLM",
            id: "29790DEE-E266-4619-B944-AB14014FBB31",
            fonasaIds: [
                "0101312"
            ],
            imedIds: [
                "0101835",
                "0101800"
            ]
        },
        {
            specialty: "Cirugia Digestiva",
            service: "Higado, Pancreas y Vias Biliares",
            id: "6C6A3720-A7D6-47AF-AB47-A9BA013105C0",
            fonasaIds: [
                "0101312"
            ],
            imedIds: [
                "0101835",
                "0101800"
            ]
        },
        {
            specialty: "Cirugia General",
            service: "General",
            id: "7C3C2CA0-8558-4270-B0A4-A9A60142B0B9",
            fonasaIds: [
                "0101312"
            ],
            imedIds: [
                "0101800",
                "0101835"
            ]
        },
        {
            specialty: "Cirugia Maxilo Facial",
            service: "General",
            id: "704F3E0D-4B9A-4CA1-BB3A-A98A00F1D489",
            fonasaIds: [
                "0101313"
            ]
        },
        {
            specialty: "Cirugia Menor",
            service: "General",
            id: "5036CA2F-E199-480E-9DBB-A98A00F1D4E6",
            fonasaIds: [
                "0101305"
            ],
            imedIds: [
                "0101849",
                "0101800"
            ]
        },
        {
            specialty: "Cirugia Oncologica",
            service: "Cabeza y Cuello",
            id: "B3D8DB68-6AF1-4ECC-B6D0-A9A60142B16B",
            fonasaIds: [
                "0101312"
            ],
            imedIds: [
                "0101801",
                "0101830",
                "0101831",
                "0101800"
            ]
        },
        {
            specialty: "Cirugia Oncologica",
            service: "Cancer de Piel",
            id: "30292893-DB57-485B-9972-A9A60142B1D8",
            fonasaIds: [
                "0101312"
            ],
            imedIds: [
                "0101801",
                "0101830",
                "0101831",
                "0101800"
            ]
        },
        {
            specialty: "Cirugia Oncologica",
            service: "General",
            id: "C98AA497-1F56-4008-AB72-A98A00F1D557",
            fonasaIds: [
                "0101312"
            ],
            imedIds: [
                "0101801",
                "0101830",
                "0101831",
                "0101800"
            ]
        },
        {
            specialty: "Cirugia Oncologica",
            service: "Mamas",
            id: "D97329D1-6323-4A5D-8A53-A9A60142B227",
            fonasaIds: [
                "0101312"
            ],
            imedIds: [
                "0101801",
                "0101830",
                "0101831",
                "0101800"
            ]
        },
        {
            specialty: "Cirugia Oncologica",
            service: "Tiroides",
            id: "3FC4A766-DBF6-4AE6-A408-A9A60142B28D",
            fonasaIds: [
                "0101312"
            ],
            imedIds: [
                "0101801",
                "0101830",
                "0101831",
                "0101800"
            ]
        },
        {
            specialty: "Cirugia Pediatrica",
            service: "General",
            id: "77EA288F-1211-45C5-88E5-A98A00F1D5A6",
            fonasaIds: [
                "0101317"
            ],
            imedIds: [
                "0101800"
            ]
        },
        {
            specialty: "Cirugia Pediatrica",
            service: "General TLM",
            id: "22313EF8-AE7A-4F8A-9CA9-AB8500B011DC",
            fonasaIds: [
                "0101317"
            ],
            imedIds: [
                "0101800"
            ]
        },
        {
            specialty: "Cirugia Plastica y Reparadora",
            service: "General",
            id: "910391CB-3DBC-4B42-825C-A98A00F1D5F6",
            fonasaIds: [
                "0101316"
            ],
            imedIds: [
                "0101809",
                "0101800"
            ]
        },
        {
            specialty: "Cirugia Plastica y Reparadora",
            service: "General TLM",
            id: "DD5F8ACE-8158-4233-9C1E-AB8500B0DC1D",
            fonasaIds: [
                "0101316"
            ],
            imedIds: [
                "0101809",
                "0101800"
            ]
        },
        {
            specialty: "Cirugia Torax",
            service: "General",
            id: "07A90886-42EF-4A09-8D9B-A98A00F1D667",
            fonasaIds: [
                "0101315"
            ],
            imedIds: [
                "0101806",
                "0101800"
            ]
        },
        {
            specialty: "Cirugia Torax",
            service: "General TLM",
            id: "4164651C-E6B3-4C18-88F3-AB8500B12BDC",
            fonasaIds: [
                "0101315"
            ],
            imedIds: [
                "0101806",
                "0101800"
            ]
        },
        {
            specialty: "Cirugia Vascular y Endovascular",
            service: "General",
            id: "95F2CE79-2750-4323-AF2A-A98A00F1D6BC",
            fonasaIds: [
                "0101318"
            ],
            imedIds: [
                "0101807",
                "0101800",
                "0101802"
            ]
        },
        {
            specialty: "Cirugia Vascular y Endovascular",
            service: "General TLM",
            id: "EEDCEED7-E227-4B37-9D1F-AB8500B1770B",
            fonasaIds: [
                "0101318"
            ],
            imedIds: [
                "0101807",
                "0101800",
                "0101802"
            ]
        },
        {
            specialty: "Dermatologia",
            service: "Dermatologia General Adulto y Niño",
            id: "4A01AA69-14E7-46DC-A2A8-A98A00F1D764",
            fonasaIds: [
                "0101201"
            ],
            imedIds: [
                "0101810",
                "0101001",
                "0101814"
            ]
        },
        {
            specialty: "Dermatologia",
            service: "Dermatologia Pediatrica",
            id: "E8AB8B12-41EC-464E-8E32-A98A00F1D894",
            fonasaIds: [
                "0101201"
            ],
            imedIds: [
                "0101810"
            ]
        },
        {
            specialty: "Dermatologia",
            service: "General Adulto TLM",
            id: "E98CC8E6-71F6-4C51-978C-AB8500B1F33F",
            fonasaIds: [
                "0101201"
            ],
            imedIds: [
                "0101810",
                "0101001",
                "0101814"
            ]
        },
        {
            specialty: "Dermatologia",
            service: "General Pediatrica TLM",
            id: "2028EC63-12BF-4DCD-AA25-AB9D00C9FFA2",
            fonasaIds: [
                "0101201"
            ],
            imedIds: [
                "0101810"
            ]
        },
        {
            specialty: "Diabetologia Adultos",
            service: "General",
            id: "7C6A2F3A-099B-4AEA-91F5-A99E01459E72",
            fonasaIds: [
                "0101320"
            ],
            imedIds: [
                "0101845",
                "0101001",
                "0101814",
                "0101307"
            ]
        },
        {
            specialty: "Diabetologia Adultos",
            service: "General TLM",
            id: "D786C6CA-84E8-4F51-A9CA-AB8500B26A1E",
            fonasaIds: [
                "0101320"
            ],
            imedIds: [
                "0101845",
                "0101001",
                "0101814",
                "0101307"
            ]
        },
        {
            specialty: "Diabetologia Pediatrica",
            service: "General",
            id: "987DF81C-029A-4546-A806-A9A60142B488",
            fonasaIds: [
                "0101320"
            ],
            imedIds: ["101845"]
        },
        {
            specialty: "Diabetologia Pediatrica",
            service: "General TLM",
            id: "D9F27094-1A15-470E-8721-AB8500B2C1F6",
            fonasaIds: [
                "0101320"
            ],
            imedIds: ["101845"]
        },
        {
            specialty: "Endocrinologia Adultos",
            service: "General",
            id: "E7AF6A09-36BA-4B1B-9B4A-A98A00F1D906",
            fonasaIds: [
                "0101207"
            ],
            imedIds: [
                "0101818",
                "0101001",
                "0101814",
                "0101307"
            ]
        },
        {
            specialty: "Endocrinologia Adultos",
            service: "General TLM",
            id: "AA4977FF-3131-4903-8827-AB860105677F",
            fonasaIds: [
                "0101207"
            ],
            imedIds: [
                "0101818",
                "0101001",
                "0101814",
                "0101307"
            ]
        },
        {
            specialty: "Endocrinologia Pediatrica",
            service: "General",
            id: "D28CE64C-1795-444B-A092-A98A00F1DAE4",
            fonasaIds: [
                "0101208"
            ],
            imedIds: [
                "0101833",
                "0101001"
            ]
        },
        {
            specialty: "Endocrinologia Pediatrica",
            service: "General TLM",
            id: "CF577543-E3C9-42D3-B177-AB8500B43608",
            fonasaIds: [
                "0101208"
            ],
            imedIds: [
                "0101833",
                "0101001"
            ]
        },
        {
            specialty: "Enfermedades Metabolicas",
            service: "General",
            id: "04E3DA4F-EB0E-47AB-8C64-A98A00F1DC0F",
            fonasaIds: [
                "0101325"
            ],
            imedIds: [
                "0101814"
            ]
        },
        {
            specialty: "Enfermeria",
            service: "Clinica de Lactancia",
            id: "B16F08EE-1133-41B9-AF81-A98A0153307A",
            imedIds: [
                "0101990"
            ]
        },
        {
            specialty: "Enfermeria",
            service: "Enfermedades Cronicas Adulto",
            id: "43ACFA3D-DDB7-4088-8F91-A98A0153333E",
            imedIds: [
                "0101943"
            ]
        },
        {
            specialty: "Enfermeria",
            service: "Evaluacion Adulto Mayor",
            id: "6C39A765-C5DB-4FB9-B657-B226010A3E09",
            imedIds: [
                "0101943"
            ]
        },
        {
            specialty: "Enfermeria",
            service: "Evaluacion Infantil",
            id: "99C9FEB2-D431-4745-8489-B2260109E15C",
            imedIds: [
                "0101943"
            ]
        },
        {
            specialty: "Fonoaudiología",
            id: "4841B364-2949-491A-BDED-A98A00F1DCD9",
            service: ""
        },
        {
            specialty: "Gastroenterologia Adultos",
            service: "General",
            id: "BA3CEBA7-D578-46CA-88B6-A98A00F1DD3B",
            fonasaIds: [
                "0101323"
            ],
            imedIds: [
                "0101820",
                "0101816",
                "0101307"
            ]
        },
        {
            specialty: "Gastroenterologia Adultos",
            service: "General TLM",
            id: "D515A82C-D3EB-4B17-9AE5-AB8500B58031",
            fonasaIds: [
                "0101323"
            ],
            imedIds: [
                "0101820",
                "0101816",
                "0101307"
            ]
        },
        {
            specialty: "Gastroenterologia Adultos",
            service: "Hepatologia",
            id: "F2B48D5F-CD54-4BFC-BDC4-A98A00F1DE00",
            fonasaIds: [
                "0101323"
            ],
            imedIds: [
                "0101820",
                "0101816",
                "0101307"
            ]
        },
        {
            specialty: "Gastroenterologia Adultos",
            service: "Hepatologia TLM",
            id: "C9915CC6-26FE-4982-A462-AC0200D863C9",
            fonasaIds: [
                "0101323"
            ],
            imedIds: [
                "0101820",
                "0101816",
                "0101307"
            ]
        },
        {
            specialty: "Gastroenterologia Pediatrica",
            service: "General",
            id: "F19FBAA7-0BAB-43A4-B45A-A98A00F1DF3A",
            fonasaIds: [
                "0101324"
            ],
            imedIds: [
                "0101826"
            ]
        },
        {
            specialty: "Gastroenterologia Pediatrica",
            service: "General TLM",
            id: "69C68E89-06CA-4242-BDB0-AB8500B5F4CA",
            fonasaIds: [
                "0101324"
            ],
            imedIds: [
                "0101826"
            ]
        },
        {
            specialty: "Genetica Clinica",
            service: "General",
            id: "5B54C186-B419-4965-8D72-A98A00F1E008",
            fonasaIds: [
                "0101325"
            ],
            imedIds: [
                "0101001"
            ]
        },
        {
            specialty: "Genetica Clinica",
            service: "General TLM",
            id: "9E3C327D-AFB7-4059-8E90-AB8500B64C46",
            fonasaIds: [
                "0101325"
            ],
            imedIds: [
                "0101001"
            ]
        },
        {
            specialty: "Geriatria",
            service: "General",
            id: "DEBB21E8-45FF-47D9-85B6-A98A00F1E06B",
            fonasaIds: [
                "0101202"
            ],
            imedIds: [
                "0101811",
                "0101001",
                "0101814",
                "0101307"
            ]
        },
        {
            specialty: "Geriatria",
            service: "General TLM",
            id: "D26553E9-F478-4A32-AA33-AB86016A75A8",
            fonasaIds: [
                "0101202"
            ],
            imedIds: [
                "0101811",
                "0101001",
                "0101814",
                "0101307"
            ]
        },
        {
            specialty: "Hematologia Adultos",
            service: "General",
            id: "F8F6C654-21AA-40C1-B903-A98A00F1E45F",
            fonasaIds: [
                "0101302"
            ],
            imedIds: [
                "0101821",
                "0101001",
                "0101814",
                "0101307",
                "0101816"
            ]
        },
        {
            specialty: "Hematologia Adultos",
            service: "General TLM",
            id: "886DE19F-089C-4FB3-84CD-AB8500B8EB9A",
            fonasaIds: [
                "0101302"
            ],
            imedIds: [
                "0101821",
                "0101001",
                "0101814",
                "0101307",
                "0101816"
            ]
        },
        {
            specialty: "Hematologia Pediatrica",
            service: "General",
            id: "9730C044-4843-4D7F-A95A-A98A00F1E62C",
            fonasaIds: [
                "0101302"
            ],
            imedIds: [
                "0101821",
                "0101836"
            ]
        },
        {
            specialty: "Hematologia Pediatrica",
            service: "General TLM",
            id: "8B19256A-C8EA-4E74-ACEB-AB8500B885B1",
            fonasaIds: [
                "0101302"
            ],
            imedIds: [
                "0101821",
                "0101836"
            ]
        },
        {
            specialty: "Infectologia Adultos",
            service: "General",
            id: "E73E62B4-29EB-465C-8AE6-A98A00F1E6CF",
            fonasaIds: [
                "0101303"
            ],
            imedIds: [
                "0101898",
                "0101001",
                "0101814",
                "0101307"
            ]
        },
        {
            specialty: "Infectologia Adultos",
            service: "General TLM",
            id: "552BFE10-98CF-4061-BC28-AB8500B98DCB",
            fonasaIds: [
                "0101303"
            ],
            imedIds: [
                "0101898",
                "0101001",
                "0101814",
                "0101307"
            ]
        },
        {
            specialty: "Infectologia Pediatrica",
            service: "General",
            id: "E660D808-77A3-412E-84B0-A98A00F1E765",
            fonasaIds: [
                "0101303"
            ],
            imedIds: ["0101898", "0101900"]
        },
        {
            specialty: "Inmunologia y Alergia Adultos",
            service: "General",
            id: "1C47A422-5E81-4718-8307-A98A00F1E7DA",
            fonasaIds: [
                "0101304"
            ],
            imedIds: [
                "0101915",
                "0101001",
                "0101846"
            ]
        },
        {
            specialty: "Inmunologia y Alergia Adultos",
            service: "General TLM",
            id: "35AF33F4-788C-477B-BCAB-AB8500C90EFB",
            fonasaIds: [
                "0101304"
            ],
            imedIds: [
                "0101915",
                "0101001",
                "0101846"
            ]
        },
        {
            specialty: "Inmunologia y Alergia Pediatrica",
            service: "General",
            id: "D1DBC7CB-7730-4335-8E82-A98A00F1E859",
            fonasaIds: [
                "0101304"
            ],
            imedIds: [
                "0101915"
            ]
        },
        {
            specialty: "Inmunologia y Alergia Pediatrica",
            service: "General TLM",
            id: "61400693-70C0-4D19-9D79-AB8500BA783D",
            fonasaIds: [
                "0101304"
            ],
            imedIds: [
                "0101915"
            ]
        },

        {
            specialty: "Manejo De Dolor No Oncologico",
            service: "Manejo de Dolor",
            id: "118F2E7C-42D2-43F3-B7BA-A98A00F1E8F3",
            fonasaIds: [
                "0101305"
            ],
            imedIds: [
                "0101849",
                "0101329"
            ]
        },
        {
            specialty: "Manejo De Dolor No Oncologico",
            service: "Manejo de Dolor TLM",
            id: "1A6250ED-A5D3-4EC2-AFB6-AB9D00E0D3DA",
            fonasaIds: [
                "0101305"
            ],
            imedIds: [
                "0101849",
                "0101329"
            ]
        },
        {
            specialty: "Matrona",
            service: "General",
            id: "BFA97D5D-CA34-48B9-8A1B-A9A60142B816",
            imedIds: [
                "2603001"
            ]
        },
        {
            specialty: "Matrona",
            service: "General TLM",
            id: "07FBBD78-255B-4795-A6D8-AB8500BB5498",
            imedIds: [
                "2603001"
            ]
        },
        {
            specialty: "Medicina Del Viajero",
            service: "Medicina del Viajero",
            id: "AA27D6F3-E1A0-4837-8737-A98A00F1EB67",
            fonasaIds: [
                "0101303"
            ],
            imedIds: [
                "0101898",
                "0101001",
                "0101814"
            ]
        },
        {
            specialty: "Medicina Del Viajero",
            service: "Medicina del Viajero TLM",
            id: "37ECD2A0-452E-45D0-803C-ABC90176935F",
            fonasaIds: [
                "0101303"
            ],
            imedIds: [
                "0101898",
                "0101001",
                "0101814"
            ]
        },
        {
            specialty: "Medicina Deportiva",
            service: "General",
            id: "C5B9C56D-E439-43EC-84D2-A9A60142B886",
            fonasaIds: [
                "0101001"
            ],
            imedIds: [
                "0101816",
                "0101814"
            ]
        },
        {
            specialty: "Medicina Deportiva",
            service: "General TLM",
            id: "DDC218BE-33FF-4F33-BA84-AC02017EB835",
            fonasaIds: [
                "0101001"
            ],
            imedIds: [
                "0101816",
                "0101814"
            ]
        },
        {
            specialty: "Medicina Familiar Adultos",
            service: "Cuidados Paliativos",
            id: "9A3A1C16-5B07-4E65-95EE-A99E01459368",
            fonasaIds: [
                "0101305"
            ],
            imedIds: [
                "0101849",
                "0101001",
                "0101814"
            ]
        },
        {
            specialty: "Medicina Familiar Adultos",
            service: "Cuidados Paliativos TLM",
            id: "3BC7BE6D-6518-4EC7-A46D-AB8D014CFD7B",
            fonasaIds: [
                "0101305"
            ],
            imedIds: [
                "0101849",
                "0101001",
                "0101814"
            ]
        },
        {
            id: "3BC7BE6D-6518-4EC7-A46D-AB8D014CFD7B",
            specialty: "Medicina Familiar Adultos",
            service: "General",
            fonasaIds: [
                "0101305"
            ],
            imedIds: [
                "0101849",
                "0101001",
                "0101814"
            ]
        },
        {
            specialty: "Medicina Familiar Adultos",
            service: "Psiquiatria de Enlace",
            id: "A54D8B7B-6830-4162-A005-A98A0153384C",
            fonasaIds: [
                "0101305"
            ],
            imedIds: [
                "0101849"
            ]
        },
        {
            id: 'medicinafamiliarninogeneral',
            specialty: "Medicina Familiar Del Niño",
            service: "General",
            fonasaIds: [
                "0101305"
            ],
            imedIds: [
                "0101849"
            ]
        },
        {
            specialty: "Medicina Familiar Del Niño",
            service: "Programa Parentalidad Positiva (Triple P)",
            id: "93B6647D-A25E-4D4F-BCBA-A98A00F209DB",
            fonasaIds: [
                "0101305"
            ],
            imedIds: [
                "0101849"
            ]
        },
        {
            specialty: "Medicina Familiar Del Niño",
            service: "Programa Parentalidad Positiva (Triple P) TLM",
            id: "32B8AC55-12DC-45B4-AE59-ACA6011518C0",
            fonasaIds: [
                "0101305"
            ],
            imedIds: [
                "0101849"
            ]
        },
        {
            specialty: "Medicina Fisica y Rehabilitacion (Fisiatria)",
            service: "Fisiatria",
            id: "946E9804-DD50-474D-B109-A99E014594BE",
            fonasaIds: [
                "0101306"
            ],
            imedIds: [
                "0101001",
                "0101814"
            ]
        },
        {
            specialty: "Medicina Fisica y Rehabilitacion (Fisiatria)",
            service: "Fisiatria TLM",
            id: "4D65037A-904C-472C-ACAB-ABA301556AA2",
            fonasaIds: [
                "0101306"
            ],
            imedIds: [
                "0101001",
                "0101814"
            ]
        },
        {
            id: 'medicinageneralgeneral',
            specialty: "Medicina General",
            service: "General",
            fonasaIds: [
                "0101001"
            ],
            imedIds: [
                "0101814"
            ]
        },
        {
            specialty: "Medicina Interna",
            service: "Cuidados Paliativos",
            id: "70A63825-3BE2-4C62-A59F-AAA100E77068",
            fonasaIds: [
                "0101307"
            ],
            imedIds: [
                "0101816",
                "0101001",
                "0101814"
            ]
        },
        {
            specialty: "Medicina Interna",
            service: "Cuidados Paliativos TLM",
            id: "5E4A604E-6181-4519-8749-ACF30119CE30",
            fonasaIds: [
                "0101307"
            ],
            imedIds: [
                "0101816",
                "0101001",
                "0101814"
            ]
        },
        {
            specialty: "Medicina Interna",
            service: "General",
            id: "D933F6E1-ABA5-47AB-8E7B-A98A00F1EFD1",
            fonasaIds: [
                "0101307"
            ],
            imedIds: [
                "0101816",
                "0101001",
                "0101814"
            ]
        },
        {
            specialty: "Medicina Interna",
            service: "General TLM",
            id: "D00F888D-6031-4A35-80CD-AB0B012329C6",
            fonasaIds: [
                "0101307"
            ],
            imedIds: [
                "0101816",
                "0101001",
                "0101814"
            ]
        },
        {
            specialty: "Medicina Paliativa",
            service: "Cuidados Paliativos",
            id: "9A3A1C16-5B07-4E65-95EE-A99E01459368",
            fonasaIds: [
                "0101307"
            ],
            imedIds: [
                "0101816",
                "0101001",
                "0101814"
            ]
        },
        {
            specialty: "Nefrologia Adultos",
            service: "General",
            id: "1CBE0A55-43B5-411D-A1F5-A98A00F1F1A2",
            fonasaIds: [
                "0101326"
            ],
            imedIds: [
                "0101822",
                "0101816",
                "0101001",
                "0101814"
            ]
        },
        {
            specialty: "Nefrologia Adultos",
            service: "General TLM",
            id: "A3124754-20ED-481B-A3BF-AB8500BC7FA1",
            fonasaIds: [
                "0101326"
            ],
            imedIds: [
                "0101822",
                "0101816",
                "0101001",
                "0101814"
            ]
        },
        {
            specialty: "Nefrologia Pediatrica",
            service: "General",
            id: "924FA341-4E7D-40E0-B2E9-A98A00F1F282",
            fonasaIds: [
                "0101327"
            ],
            imedIds: [
                "0101837",
                "0101803"
            ]
        },
        {
            specialty: "Nefrologia Pediatrica",
            service: "General TLM",
            id: "9444F65E-B7C6-4439-9795-AB8500BD26FC",
            fonasaIds: [
                "0101327"
            ],
            imedIds: [
                "0101837",
                "0101803"
            ]
        },
        {
            specialty: "Neurocirugia",
            service: "General",
            id: "4013BC29-E6C8-4208-92EC-A98A00F1F461",
            fonasaIds: [
                "0101203"
            ],
            imedIds: [
                "0101824",
                "0101001",
                "0101814"
            ]
        },
        {
            specialty: "Neurocirugia",
            service: "General TLM",
            id: "C2B27958-D77D-4BF4-BCE8-AB8500BDFAF5",
            fonasaIds: [
                "0101203"
            ],
            imedIds: [
                "0101824",
                "0101001",
                "0101814"
            ]
        },
        {
            specialty: "Neurologia Adultos",
            service: "Enfermedades Neuromusculares",
            id: "3FC84598-646B-4F84-840C-AC5301090A13",
            fonasaIds: [
                "0101209"
            ],
            imedIds: [
                "0101825",
                "0101001"
            ]
        },
        {
            specialty: "Neurologia Adultos",
            service: "General",
            id: "8DDB7930-AB9D-4FD5-B278-A98A00F1F54B",
            fonasaIds: [
                "0101209"
            ],
            imedIds: [
                "0101825",
                "0101814"
            ]
        },
        {
            specialty: "Neurologia Adultos",
            service: "General TLM",
            id: "4BCBB722-73C1-4D5D-A8D8-AB8500BE7B55",
            fonasaIds: [
                "0101209"
            ],
            imedIds: [
                "0101825",
                "0101814"
            ]
        },
        {
            specialty: "Neurologia Adultos",
            service: "Manejo Dolor Cronico",
            id: "9260B5C8-E8FB-4946-876C-B0DF0168B134",
            fonasaIds: [
                "0101209"
            ],
            imedIds: [
                "0101825"
            ]
        },
        {
            specialty: "Neurologia Adultos",
            service: "Neuroinmunologia",
            id: "0BFFF75A-6311-4666-8C23-AF1D01167D9C",
            fonasaIds: [
                "0101209"
            ],
            imedIds: [
                "0101825"
            ]
        },
        {
            specialty: "Neurologia Adultos",
            service: "Neurorrehabilitacion",
            id: "83D981F2-9206-44E8-B401-A98A00F1F5B6",
            fonasaIds: [
                "0101209"
            ],
            imedIds: [
                "0101825"
            ]
        },
        {
            specialty: "Neurologia Adultos",
            service: "Oncologia",
            id: "BAEDB22B-497C-4BE1-853C-A99E01459B47",
            fonasaIds: [
                "0101209"
            ],
            imedIds: [
                "0101825"
            ]
        },
        {
            specialty: "Neurologia Adultos",
            service: "Problemas Cognitivos y Memoria",
            id: "90548AF8-A019-4568-898D-A98A00F1F630",
            fonasaIds: [
                "0101209"
            ],
            imedIds: [
                "0101825"
            ]
        },
        {
            specialty: "Neurologia Adultos",
            service: "Problemas Cognitivos y Memoria TLM",
            id: "8331181D-7475-464C-B5E9-ACC500FCD799",
            fonasaIds: [
                "0101209"
            ],
            imedIds: [
                "0101825"
            ]
        },
        {
            specialty: "Neurologia Adultos",
            service: "Temblor y Parkinson",
            id: "21E1CEB8-08BB-46E9-8783-AB4F012043F0",
            fonasaIds: [
                "0101209"
            ],
            imedIds: [
                "0101825"
            ]
        },
        {
            specialty: "Neurologia Adultos",
            service: "Temblor y Parkinson TLM",
            id: "8253FC12-9CEA-475C-9AF2-AB9D00C5B192",
            fonasaIds: [
                "0101209"
            ],
            imedIds: [
                "0101825"
            ]
        },
        {
            specialty: "Neurologia Adultos",
            service: "Trastorno del Sueño",
            id: "65C8B928-8E8F-4316-A3D3-A98A00F1F72E",
            fonasaIds: [
                "0101209"
            ],
            imedIds: [
                "0101825"
            ]
        },
        {
            specialty: "Neurologia Adultos",
            service: "Trastorno del Sueño TLM",
            id: "2C99C8BE-5549-4C76-9C3F-AB9D00C61CFC",
            fonasaIds: [
                "0101209"
            ],
            imedIds: [
                "0101825"
            ]
        },
        {
            specialty: "Neurologia Pediatrica",
            service: "General",
            id: "874E8E2D-51EB-424E-891A-A98A00F1F7AD",
            fonasaIds: [
                "0101210"
            ],
            imedIds: [
                "0101844",
                "0101001",
                "0101814",
                "0101803"
            ]
        },
        {
            specialty: "Neurologia Pediatrica",
            service: "General TLM",
            id: "1C955310-62B6-4B95-9432-AB8500BF08ED",
            fonasaIds: [
                "0101210"
            ],
            imedIds: [
                "0101844",
                "0101001",
                "0101814",
                "0101803"
            ]
        },
        {
            specialty: "Neurologia Pediatrica",
            service: "Neurorrehabilitacion",
            id: "1E2B51BE-BE6F-4F0E-A9F5-A9AC00F7FC64",
            fonasaIds: [
                "0101210"
            ],
            imedIds: [
                "0101844"
            ]
        },
        {
            specialty: "Nutricion Medica Adultos",
            service: "General",
            id: "9DCDEAC7-F1B5-45EE-A545-A99E0145A283",
            fonasaIds: [
                "0101320"
            ],
            imedIds: [
                "0101845",
                "0101001",
                "0101814"
            ]
        },
        {
            specialty: "Nutricion Medica Adultos",
            service: "General TLM",
            id: "F49E76C2-F7D3-4FB3-B149-AB8500C234D1",
            fonasaIds: [
                "0101320"
            ],
            imedIds: [
                "0101845",
                "0101001",
                "0101814"
            ]
        },
        {
            specialty: "Nutricion Medica Adultos",
            service: "Trastornos de la Alimentacion",
            id: "277A1C3B-F105-4BAB-A6EF-AC9500FF9C05",
            fonasaIds: [
                "0101320"
            ],
            imedIds: [
                "0101845"
            ]
        },
        {
            specialty: "Nutricion Medica Adultos",
            service: "Trastornos de la Alimentacion TLM",
            id: "D0BF691F-3275-4305-AE83-AC47014C1A63",
            fonasaIds: [
                "0101320"
            ],
            imedIds: [
                "0101845"
            ]
        },
        {
            specialty: "Nutricion Medica Pediatrica",
            service: "General",
            id: "089A12CB-EC4C-43CF-B17A-A98A00F1F9B4",
            fonasaIds: [
                "0101320"
            ],
            imedIds: [
                "0101845",
                "0101803"
            ]
        },
        {
            specialty: "Nutricion Medica Pediatrica",
            service: "General TLM",
            id: "8E5D7E87-11AC-4E9C-A365-AB8500C07CE5",
            fonasaIds: [
                "0101320"
            ],
            imedIds: [
                "0101845",
                "0101803"
            ]
        },
        {
            specialty: "Nutricion Medica Pediatrica",
            service: "Trastornos de la Alimentacion",
            id: "6D1636F0-9FCC-46E0-8612-A99E01459E06",
            fonasaIds: [
                "0101320"
            ],
            imedIds: [
                "0101845"
            ]
        },
        {
            specialty: "Nutricion Medica Pediatrica",
            service: "Trastornos de la Alimentacion TLM",
            id: "FEAF2142-5748-438F-B70B-AC47014CABFF",
            fonasaIds: [
                "0101320"
            ],
            imedIds: [
                "0101845"
            ]
        },
        {
            specialty: "Nutricionista",
            service: "Diabetes",
            id: "7B97826B-EE8D-45E9-AB39-A9AC01013305"
        },
        {
            specialty: "Nutricionista",
            service: "Diabetes Pediatrico",
            id: "6871C9E9-7365-4979-9155-A9D70135C5E6"
        },
        {
            specialty: "Nutricionista",
            service: "Embarazo",
            id: "76BAB1B2-921A-40EA-BDF3-A98A00F1FD21"
        },
        {
            specialty: "Nutricionista",
            service: "Enfermedad Renal Cronica",
            id: "BA94F113-410A-4A5D-9B18-AB7D013BE4CA"
        },
        {
            specialty: "Nutricionista",
            service: "Enfermedades Gastrointestinales",
            id: "84A99D55-35D9-4BFD-A6EE-AB7D0148B82F"
        },
        {
            specialty: "Nutricionista",
            service: "General Adulto",
            id: "FFD1DA4E-F1D6-4D6D-AE7E-A98A00F1FCA2"
        },
        {
            specialty: "Nutricionista",
            service: "General Pediatrico",
            id: "A3DA2460-DB3C-46B3-B378-A98A00F1FDA4"
        },
        {
            specialty: "Nutricionista",
            service: "Medicina Deportiva",
            id: "F9339C66-F7C0-495C-9732-A9AF0129780D"
        },
        {
            specialty: "Nutricionista",
            service: "Obesidad",
            id: "870681CF-A0CD-4C5B-8309-A98A00F1FE1A"
        },
        {
            specialty: "Nutricionista",
            service: "Oncologia",
            id: "AD4AAAEA-C68A-421C-8DB9-A9BE016081AC"
        },
        {
            specialty: "Nutricionista",
            service: "Trastorno Alimentacion",
            id: "3026041F-B9A9-4842-927A-AC9500FE4F24"
        },
        {
            specialty: "Oncologia Adultos",
            service: "General",
            id: "03DEBD86-B945-4B46-A3E4-A98A00F203A6",
            fonasaIds: [
                "0101211"
            ],
            imedIds: [
                "0101831",
                "0101001",
                "0101814",
                "0101307"
            ]
        },
        {
            specialty: "Oncologia Adultos",
            service: "General TLM",
            id: "9A36F63B-50BC-46A3-A40B-AB8500C45A51",
            fonasaIds: [
                "0101211"
            ],
            imedIds: [
                "0101831",
                "0101001",
                "0101814",
                "0101307"
            ]
        },
        {
            specialty: "Oncologia Pediatrica",
            service: "General",
            id: "3F57A3C1-239C-4BAA-B83C-A99E0145A664",
            fonasaIds: [
                "0101211"
            ],
            imedIds: [
                "0101831"
            ]
        },
        {
            specialty: "Oncologia Pediatrica",
            service: "General TLM",
            id: "D6CC8A92-DB36-4A24-89D3-AB8500B80E4A",
            fonasaIds: [
                "0101211"
            ],
            imedIds: [
                "0101831"
            ]
        },
        {
            specialty: "Otorrinolaringologia",
            service: "General",
            id: "7BFFF2DE-5F19-4F04-88A5-A98A00F204B1",
            fonasaIds: [
                "0101205"
            ],
            imedIds: [
                "0101829",
                "0101001",
                "0101814"
            ]
        },
        {
            specialty: "Otorrinolaringologia",
            service: "General TLM",
            id: "3C15A2A8-4524-420C-A47A-AB8500C4A969",
            fonasaIds: [
                "0101205"
            ],
            imedIds: [
                "0101829",
                "0101001",
                "0101814"
            ]
        },
        {
            specialty: "Parasitologia",
            service: "General",
            id: "26D99FE7-EDA2-421A-AE4C-A98A015338B8",
            fonasaIds: [
                "0101303"
            ],
            imedIds: [
                "0101898",
                "0101001",
                "0101814",
                "0101307"
            ]
        },
        {
            specialty: "Pediatria",
            service: "Atencion con Lengua de Señas TLM",
            id: "A1DD1A2F-299F-41CE-A156-AC130106F961",
            fonasaIds: [
                "0101309"
            ],
            imedIds: [
                "0101803",
                "0101849",
                "0101305"
            ]
        },
        {
            id: 'pediatriageneral',
            specialty: "Pediatria",
            service: "General",
            fonasaIds: [
                "0101309"
            ],
            imedIds: [
                "0101803",
                "0101849",
                "0101305"
            ]
        },
        {
            specialty: "Pediatria",
            service: "Necesidades Especiales",
            id: "F09B7144-34EC-465B-B582-A98A00F208D0",
            fonasaIds: [
                "0101309"
            ],
            imedIds: [
                "0101803",
                "0101849",
                "0101305"
            ]
        },
        {
            specialty: "Pediatria",
            service: "Neonatologia",
            id: "BD7FF297-B4E5-4BF9-B0E8-A98A00F1F3DD",
            fonasaIds: [
                "0101328"
            ],
            imedIds: [
                "0101803",
                "0101849",
                "0101305"
            ]
        },
        {
            specialty: "Pediatria",
            service: "Neonatologia TLM",
            id: "58B4E9DD-0DAC-45E5-B469-AB8500BD7B37",
            fonasaIds: ["0101328"],
            imedIds: ["0101803", "0101849", "0101305"]
        },
        {
            id: "2",
            specialty: "Urgencia Clinica San Carlos",
            service: ""
        },
        {
            id: "12",
            specialty: "Urgencia Externa",
            service: ""
        },
        {
            id: "1",
            specialty: "Urgencia Hospital Clinico Marcoleta",
            service: ""
        },
        {
            id: "10",
            specialty: "Seguimiento Orientacion Quirurgica",
            service: ""
        },
        {
            specialty: "Pediatria",
            service: "Seguimiento a Prematuro",
            id: "BBA2E8AB-5FFB-4329-B4AB-A99E0145AA80",
            fonasaIds: [
                "0101309"
            ],
            imedIds: [
                "0101803",
                "0101849",
                "0101305"
            ]
        },
        {
            id: 'cefaleas',
            specialty: "Programa Cefaleas",
            service: "UC",
            fonasaIds: [
                "0101209"
            ],
            imedIds: [
                "0101825",
                "0101001"
            ]
        },
        {
            id: 'insuficiencia',
            specialty: "Programa de Insuficiencia Cardiaca",
            service: "UC",
            fonasaIds: [
                "0101301"
            ],
            imedIds: [
                "0101817"
            ]
        },
        {
            specialty: "Programa Espacio Balance",
            service: "Evaluacion Adulto TLM",
            id: "B2A1FEB0-FDC0-41B7-8CF2-AC3601058CA3"
        },
        {
            specialty: "Programa Espacio Balance",
            service: "Evaluacion Pediatrica TLM",
            id: "D9014DE1-1FCD-48F0-8D0A-AC36010A8959"
        },
        {
            specialty: "Psicologia Adulto",
            service: "Cuidados Paliativos",
            id: "B55D5A8D-9300-44E5-8A23-A9B1006C3C64",
            fonasaIds: [
                "0902001"
            ],
            imedIds: [
                "0902002",
                "0101855"
            ]
        },
        {
            specialty: "Psicologia Adulto",
            service: "General",
            id: "096EB5DD-935B-4BEA-8E7A-A98A00F20AEB",
            fonasaIds: [
                "0902001"
            ],
            imedIds: [
                "0902002",
                "0101855"
            ]
        },
        {
            specialty: "Psicologia Adulto",
            service: "Geriatria",
            id: "1B173B76-1AD2-4F40-B8E6-A98A00F20D1D",
            fonasaIds: [
                "0902001"
            ],
            imedIds: [
                "0902002",
                "0101855"
            ]
        },
        {
            specialty: "Psicologia Adulto",
            service: "Manejo Dolor No Oncologico",
            id: "306B7921-E18B-4550-AF34-A98A00F20DAA",
            fonasaIds: [
                "0902001"
            ],
            imedIds: [
                "0902002",
                "0101855"
            ]
        },
        {
            specialty: "Psicologia Adulto",
            service: "Medicina Deportiva",
            id: "A8FBC660-3779-40B5-854B-A9A60142BD77",
            fonasaIds: [
                "0902001"
            ],
            imedIds: [
                "0902002",
                "0101855"
            ]
        },
        {
            specialty: "Psicologia Adulto",
            service: "Neuropsicologia",
            id: "B14A8CBB-F0EB-4923-8E55-A98A00F20E37",
            fonasaIds: [
                "0902001"
            ],
            imedIds: [
                "0902002",
                "0101855"
            ]
        },
        {
            specialty: "Psicologia Adulto",
            service: "Obstetricia",
            id: "346CF161-5B03-4551-8D8F-A98A00F20F50",
            fonasaIds: [
                "0902001"
            ],
            imedIds: [
                "0902002",
                "0101855"
            ]
        },
        {
            specialty: "Psicologia Adulto",
            service: "Oncologia",
            id: "DDE53459-6FF9-4B58-8E21-A9B1006C69BE",
            fonasaIds: [
                "0902001"
            ],
            imedIds: [
                "0902002",
                "0101855"
            ]
        },
        {
            specialty: "Psicologia Adulto",
            service: "Programa Obesidad",
            id: "9ADD62E2-4CE3-41C8-B20B-A98A01533A84",
            fonasaIds: [
                "0902001"
            ],
            imedIds: [
                "0902002",
                "0101855"
            ]
        },
        {
            id: "7",
            specialty: "Terapia Ocupacional",
            service: ""
        },
        {
            specialty: "Psicologia Adulto",
            service: "Terapia Familiar",
            id: "A00A7EAD-E8DF-4C28-9855-A98A00F211EA",
            fonasaIds: [
                "0902001"
            ],
            imedIds: [
                "0902002",
                "0101855"
            ]
        },
        {
            specialty: "Psicologia Adulto",
            service: "Trastorno Del Sueño",
            id: "DE5693D7-106C-409B-8689-A98A00F20C0D",
            fonasaIds: [
                "0902001"
            ],
            imedIds: [
                "0902002",
                "0101855"
            ]
        },
        {
            specialty: "Psicologia Pediatrica y Adolescente",
            service: "General",
            id: "94816ED5-8974-45E7-A21D-A98A0153396A",
            fonasaIds: [
                "0902001"
            ],
            imedIds: [
                "0902002"
            ]
        },
        {
            specialty: "Psicologia Pediatrica y Adolescente",
            service: "Trastornos De La Alimentacion",
            id: "C28572F5-6B4E-4CE5-8BFB-AE6A00F2F0E4",
            fonasaIds: [
                "0902001"
            ],
            imedIds: [
                "0902002"
            ]
        },
        {
            specialty: "Psiquiatria Adultos",
            service: "Adicciones",
            id: "E1B2DE90-4C94-4DB6-9AEA-A9A60142BECD",
            fonasaIds: [
                "0901005"
            ],
            imedIds: [
                "0101854"
            ]
        },
        {
            specialty: "Psiquiatria Adultos",
            service: "DBT (Terapia Conductual Dialectica)",
            id: "E3F62FC7-7227-4E05-A394-A98A01533BA1",
            fonasaIds: [
                "0901005"
            ],
            imedIds: [
                "0101854"
            ]
        },
        {
            specialty: "Psiquiatria Adultos",
            service: "General",
            id: "D331295F-8BE0-4F37-AC91-A98A00F21658",
            fonasaIds: [
                "0101212"
            ],
            imedIds: [
                "0101854"
            ]
        },
        {
            specialty: "Psiquiatria Adultos",
            service: "General TLM",
            id: "61E59F22-2452-4F80-8138-AB8500C6FA2A",
            fonasaIds: [
                "0101212"
            ],
            imedIds: [
                "0101854"
            ]
        },
        {
            specialty: "Psiquiatria Adultos",
            service: "Trastornos de la Alimentacion",
            id: "31BCC498-5750-43F6-BAEC-A9A60142BF92",
            fonasaIds: [
                "0101212"
            ],
            imedIds: [
                "0101854"
            ]
        },
        {
            specialty: "Psiquiatria Adultos",
            service: "Trastornos de la Alimentacion TLM",
            id: "217D2BA9-301D-47F2-B3FA-AC36010BDE15",
            fonasaIds: [
                "0101212"
            ],
            imedIds: [
                "0101854"
            ]
        },
        {
            id: '17',
            specialty: 'Psiquiatría de Enlace y Medicina Psicosomática Ambulatoria',
            service: '(PEMP Ambulatorio)',
        },
        {
            specialty: "Psiquiatria Pediatrica y Adolescente",
            service: "General",
            id: "5A091E76-EEE1-49B7-8E75-A98A01533BFA",
            fonasaIds: [
                "0101213"
            ],
            imedIds: [
                "0101853"
            ]
        },
        {
            specialty: "Psiquiatria Pediatrica y Adolescente",
            service: "General TLM",
            id: "5D6066C1-5919-4B25-AAC0-AB8500C74DEF",
            fonasaIds: [
                "0101213"
            ],
            imedIds: [
                "0101853"
            ]
        },
        {
            specialty: "Psiquiatria Pediatrica y Adolescente",
            service: "Trastornos de la Alimentacion",
            id: "5D039C02-52D7-4C66-9450-AC9500FD30A7",
            fonasaIds: [
                "0101213"
            ],
            imedIds: [
                "0101853"
            ]
        },
        {
            specialty: "Psiquiatria Pediatrica y Adolescente",
            service: "Trastornos de la Alimentacion TLM",
            id: "2685F1ED-CE9D-42EE-AF18-AC4700D485B3",
            fonasaIds: [
                "0101213"
            ],
            imedIds: [
                "0101853"
            ]
        },
        {
            specialty: "Radioterapia",
            service: "General",
            id: "D8CF4358-451F-4582-8A01-AC150143AA05",
            fonasaIds: [
                "0101331"
            ],
            imedIds: [
                "0101001",
                "0101814"
            ]
        },
        {
            specialty: "Radioterapia",
            service: "General TLM",
            id: "B15073C3-97F3-4508-861B-AB8500C84899",
            fonasaIds: [
                "0101331"
            ],
            imedIds: [
                "0101001",
                "0101814"
            ]
        },
        {
            specialty: "Reumatologia Adultos",
            service: "General",
            id: "1704B22A-E87C-49C7-95EA-A98A00F21BFD",
            fonasaIds: [
                "0101206"
            ],
            imedIds: [
                "0101838",
                "0101307",
                "0101001",
                "0101814"
            ]
        },
        {
            specialty: "Reumatologia Adultos",
            service: "General TLM",
            id: "81725646-C223-4D2A-8353-AB8500C8C30A",
            fonasaIds: [
                "0101206"
            ],
            imedIds: [
                "0101838",
                "0101307",
                "0101001",
                "0101814"
            ]
        },
        {
            specialty: "Reumatologia Pediatrica",
            service: "General",
            id: "B942A550-89D3-4D4D-95FA-A9A60142C0DB",
            fonasaIds: [
                "0101206"
            ],
            imedIds: [
                "0101838"
            ]
        },
        {
            specialty: "Reumatologia Pediatrica",
            service: "General TLM",
            id: "E7E8C4E9-82D7-48A7-86B0-AB8500BAF178",
            fonasaIds: [
                "0101206"
            ],
            imedIds: [
                "0101838"
            ]
        },
        {
            specialty: "Traumatologia Adulto",
            service: "Caderas",
            id: "D4ABAE3C-C5CF-485E-9E3B-A98A00F2224A",
            fonasaIds: [
                "0101310"
            ],
            imedIds: [
                "0101841",
                "0101001",
                "0101814"
            ]
        },
        {
            specialty: "Traumatologia Adulto",
            service: "Caderas TLM",
            id: "69E3FC99-55D2-4E88-A5CF-ABC1004985D0",
            fonasaIds: [
                "0101310"
            ],
            imedIds: [
                "0101841",
                "0101001",
                "0101814"
            ]
        },
        {
            specialty: "Traumatologia Adulto",
            service: "Codo",
            id: "266195AC-1AA6-4B9A-A905-A9AD012C0958",
            fonasaIds: [
                "0101310"
            ],
            imedIds: [
                "0101841"
            ]
        },
        {
            specialty: "Traumatologia Adulto",
            service: "Codo TLM",
            id: "1DA332CB-907A-4DEC-85A3-ABC10048F876",
            fonasaIds: [
                "0101310"
            ],
            imedIds: [
                "0101841"
            ]
        },
        {
            specialty: "Traumatologia Adulto",
            service: "Columna",
            id: "06F17B36-06A6-46C8-83E8-A98A00F22798",
            fonasaIds: [
                "0101310"
            ],
            imedIds: [
                "0101841"
            ]
        },
        {
            specialty: "Traumatologia Adulto",
            service: "Columna TLM",
            id: "2D18A4BE-A14E-4B52-82B3-ABC100495754",
            fonasaIds: [
                "0101310"
            ],
            imedIds: [
                "0101841"
            ]
        },
        {
            specialty: "Traumatologia Adulto",
            service: "General",
            id: "9AD5C7E2-2521-4EBE-9325-A98A00F221AE",
            fonasaIds: [
                "0101310"
            ],
            imedIds: [
                "0101841"
            ]
        },
        {
            specialty: "Traumatologia Adulto",
            service: "General TLM",
            id: "C783181F-2690-4839-B008-AB8500C9F91A",
            fonasaIds: [
                "0101310"
            ],
            imedIds: [
                "0101841"
            ]
        },
        {
            specialty: "Traumatologia Adulto",
            service: "Hombro",
            id: "326D7080-98E8-49BE-ADCB-A98A00F222DB",
            fonasaIds: [
                "0101310"
            ],
            imedIds: [
                "0101841"
            ]
        },
        {
            specialty: "Traumatologia Adulto",
            service: "Hombro TLM",
            id: "22B360BC-4B09-47A8-8907-ABC100492429",
            fonasaIds: [
                "0101310"
            ],
            imedIds: [
                "0101841"
            ]
        },
        {
            specialty: "Traumatologia Adulto",
            service: "Manos",
            id: "8658D443-964F-463F-83B3-A98A00F22379",
            fonasaIds: [
                "0101310"
            ],
            imedIds: [
                "0101841"
            ]
        },
        {
            specialty: "Traumatologia Adulto",
            service: "Manos TLM",
            id: "134AC1FF-20A5-4BC9-A547-ABC10048CEB7",
            fonasaIds: [
                "0101310"
            ],
            imedIds: [
                "0101841"
            ]
        },
        {
            specialty: "Traumatologia Adulto",
            service: "Rodillas",
            id: "75C9A538-D50A-49F0-859B-A98A00F225CD",
            fonasaIds: [
                "0101310"
            ],
            imedIds: [
                "0101841"
            ]
        },
        {
            specialty: "Traumatologia Adulto",
            service: "Rodillas TLM",
            id: "30906E6E-FF69-40EE-8489-ABC10049B23F",
            fonasaIds: [
                "0101310"
            ],
            imedIds: [
                "0101841"
            ]
        },
        {
            specialty: "Traumatologia Adulto",
            service: "Tobillo y Pie",
            id: "F641C34A-4AC8-4262-9909-A98A00F2240B",
            fonasaIds: [
                "0101310"
            ],
            imedIds: [
                "0101841"
            ]
        },
        {
            specialty: "Traumatologia Adulto",
            service: "Tobillo y Pie TLM",
            id: "241E9818-60EC-4A8B-9A4E-ABC10049DDC1",
            fonasaIds: [
                "0101310"
            ],
            imedIds: [
                "0101841"
            ]
        },
        {
            specialty: "Traumatologia Adulto",
            service: "Traumatologia Deportiva",
            id: "FB0AD74E-9A48-4F61-B82C-A9A60142C34F",
            fonasaIds: [
                "0101310"
            ],
            imedIds: [
                "0101841"
            ]
        },
        {
            specialty: "Traumatologia Adulto",
            service: "Traumatologia Deportiva TLM",
            id: "2DA17292-2865-40BC-BC57-ABC9017236EA",
            fonasaIds: [
                "0101310"
            ],
            imedIds: [
                "0101841"
            ]
        },
        {
            specialty: "Traumatologia Adulto",
            service: "Tumores Musculoesqueleticos",
            id: "E1A7F9E9-8A0E-490F-B002-AC6901401509",
            fonasaIds: [
                "0101310"
            ],
            imedIds: [
                "0101841"
            ]
        },
        {
            specialty: "Traumatologia Adulto",
            service: "Tumores Musculoesqueleticos TLM",
            id: "D5EB3246-A26A-4358-8F8F-ABC1004A1368",
            fonasaIds: [
                "0101310"
            ],
            imedIds: [
                "0101841"
            ]
        },
        {
            specialty: "Traumatologia Pediatrica",
            service: "General",
            id: "41424E8E-CD3F-4034-9870-A98A00F22833",
            fonasaIds: [
                "0101310"
            ],
            imedIds: [
                "0101841"
            ]
        },
        {
            specialty: "Traumatologia Pediatrica",
            service: "General TLM",
            id: "F09A3FF1-4903-44FC-BC52-AB920035B6A4",
            fonasaIds: [
                "0101310"
            ],
            imedIds: [
                "0101841"
            ]
        },
        {
            specialty: "Traumatologia Pediatrica",
            service: "Tumores Musculoesqueleticos",
            id: "643F7AED-DF6A-471A-9E3C-AC6901406B33",
            fonasaIds: [
                "0101310"
            ],
            imedIds: [
                "0101841"
            ]
        },
        {
            specialty: "Traumatologia Pediatrica",
            service: "Tumores Musculoesqueleticos TLM",
            id: "69ABC542-17C6-4A4C-A9B2-AC78017802E8",
            fonasaIds: [
                "0101310"
            ],
            imedIds: [
                "0101841"
            ]
        },
        {
            id: 'saludmentalintegral',
            specialty: "Unidad Salud Mental Integral",
            service: "Psiquiatria o Psicologia",
            fonasaIds: ["0101001", "0101305"],
            imedIds: ["0101849", "0101814"]
        },
        {
            specialty: "Urologia Adultos",
            service: "General",
            id: "DE4149F2-B4B0-4372-91FF-A98A00F228C9",
            fonasaIds: [
                "0101311"
            ],
            imedIds: [
                "0101834",
                "0101814"
            ]
        },
        {
            specialty: "Urologia Adultos",
            service: "General TLM",
            id: "5E7802A5-EB03-4290-AB1E-AB8500CA7F93",
            fonasaIds: [
                "0101311"
            ],
            imedIds: [
                "0101834",
                "0101814"
            ]
        },
        {
            specialty: "Urologia Adultos",
            service: "Incontinencia Urinaria",
            id: "093F2633-6BC7-45A4-AFD3-A98A00F229F0",
            fonasaIds: [
                "0101311"
            ],
            imedIds: [
                "0101834"
            ]
        },
        {
            specialty: "Urologia Pediatrica",
            service: "General",
            id: "8A224F09-A88C-44FE-805C-A98A00F22A8B",
            fonasaIds: [
                "0101311"
            ],
            imedIds: [
                "0101834",
                "0101839"
            ]
        },
        {
            specialty: "Urologia Pediatrica",
            service: "General TLM",
            id: "D1446AB5-C3D3-4BBD-B42C-AB8500CAC640",
            fonasaIds: [
                "0101311"
            ],
            imedIds: [
                "0101834",
                "0101839"
            ]
        }
    ],
    noIh: [
        {
            id: '1',
            specialty: 'Urgencia Hospital Clinico Marcoleta',
            service: '',
        },
        {
            id: '2',
            specialty: 'Urgencia Clinica San Carlos',
            service: '',
        },
        {
            id: '3',
            specialty: 'Otra Especialidad',
            service: '',
        },

        {
            id: '5',
            specialty: 'Nutricionista',
            service: '',
        },
        {
            id: '6',
            specialty: 'Psicologia',
            service: '',
        },
        {
            id: '7',
            specialty: 'Terapia Ocupacional',
            service: '',
        },
        {
            id: '4841B364-2949-491A-BDED-A98A00F1DCD9',
            specialty: 'Fonoaudiología',
            service: '',
        },
        {
            id: '9',
            specialty: 'Psicopedagogia',
            service: '',
        },
        {
            id: '10',
            specialty: 'Seguimiento Orientacion Quirurgica',
            service: '',
        },
        {
            id: '11',
            specialty: 'Enfermeria',
            service: '',
        },
        {
            id: '12',
            specialty: 'Urgencia Externa',
            service: '',
        },
        {
            id: '13',
            specialty: 'Pre Dialisis',
            service: '',
        },
        {
            id: '14',
            specialty: 'Programa de Insuficiencia Cardiaca UC',
            service: '',
        },
        {
            id: '15',
            specialty: 'Programa Cefaleas UC',
            service: '',
        },
        {
            id: '17',
            specialty: 'Psiquiatría de Enlace y Medicina Psicosomática Ambulatoria (PEMP Ambulatorio)',
            service: '',
        },
        {
            id: '16',
            specialty: 'Unidad Salud Mental Integral Psiquiatria o Psicologia',
            service: '',
        },
        {
            specialty: 'Kinesiología',
            id: '946024DA-B3A7-4B58-B985-AB3B00BF5413',
            service: '',
        },
        {
            id: '17',
            specialty: 'Programa Espacio Balance',
            service: '',
        },
    ],
};
